// extracted by mini-css-extract-plugin
export var locationsContainer = "_zg-2";
export var locationsTextContainer = "_zg-1";
export var mapContainer = "_zg-0";